import {useEffect, useState} from 'react';
import {
  IonContent,
  IonItem,
  IonList,
  IonPopover,
  IonReorder,
  IonReorderGroup,
  IonRouterLink,
  IonSegment,
  IonSegmentButton,
} from '@ionic/react';
import {useHistory} from 'react-router';
import {FiArrowRight} from 'react-icons/fi';
import {BsThreeDotsVertical} from 'react-icons/bs';
import {useRecoilValue} from 'recoil';
import {ownDeclaration} from '../state/ownDeclaration';
import actions from '../api/ownDeclaration';
import useFetchOwnDeclaration from '../hooks/useFetchOwnDeclaration';
import chips from '../utilis/chips';
import UIButton from '../components/UICommon/UIButton';
import UICard from '../components/UICommon/UICard';
import UIErrorIndicator from '../components/UICommon/UIErrorIndicator';
import UILoadingIndicator from '../components/UICommon/UILoadingIndicator';
import UINoDataIndicator from '../components/UICommon/UINoDataIndicator';

const OwnDeclarationPage: React.FC = () => {
  const [tabValue, setTabValue] = useState('new-questions');
  const [isReorder, setReorder] = useState(false);
  const {isLoading, isError, refetch} = useFetchOwnDeclaration();
  const ownDeclarationData: any = useRecoilValue(ownDeclaration);
  const history = useHistory();

  const newTabValue = (value: string) => {
    setTabValue(value);
  };

  const goToEdit = (el: any) => {
    const id = el.id;
    if (el?.type === 'text') {
      history.push(`/egen-deklaration/${id}/endast-text`);
    } else if (el?.type === 'fill') {
      history.push(`/egen-deklaration/${id}/fylla-text`);
    } else if (el?.type === 'boolean') {
      history.push(`/egen-deklaration/${id}/checkbox-fraga`);
    } else {
      return null;
    }
  };

  function doReorder(event: CustomEvent) {
    const orderData = [...ownDeclarationData];
    const from = event.detail.from;
    const to = event.detail.to;
    const itemToMove = orderData.splice(from, 1)[0];
    orderData.splice(to, 0, itemToMove);

    const tmpOrderData: any = [];
    orderData.forEach((element: any, idx: number) => {
      tmpOrderData.push({id: element.id, order: idx + 1});
    });
    event.detail.complete();
    actions.reOrderQuestion({questions: tmpOrderData});
  }

  const toggleReorder = () => {
    setReorder(!isReorder);
  };

  useEffect(() => {
    refetch();
  }, []);

  return (
    <div className='bg-white h-full'>
      <div className='h-[10%] md:hidden'>
        <IonSegment mode='md' onIonChange={(e) => e.detail.value && newTabValue(e.detail.value)} value={tabValue}
          className='md:hidden w-full mt-5 border-b-2 border-neutral-100'>
          <IonSegmentButton value='new-questions' className='normal-case
          text-lg font-Outfit text-navy-primary w-1/2'>Nya fält</IonSegmentButton>
          <IonSegmentButton value='saved-questions' className='normal-case text-lg
          font-Outfit text-navy-primary w-1/2'>Sparade fält</IonSegmentButton>
        </IonSegment>
      </div>
      <div className='flex h-[90%] overflow-y-scroll mb-10 md:pb-20 md:space-x-6 px-6'>
        <UICard
          style={`${tabValue === 'new-questions' ? 'flex' : 'hidden'} md:flex flex-col md:pl-9`}>
          <div className='hidden md:block font-Outfit font-medium text-22 text-black-ink'>Nya fält</div>
          <div className='font-Outfit font-medium text-22 md:text-sm text-black-ink md:text-brown-subtitle'>
            Vad för fält vill du skapa till hälsodeklarationen?</div>
          <div className='h-full flex space-y-5 flex-col py-4 md:py-7 md:pr-20'>
            {chips.map((el: {text: string, description: string, href: string}, idx: number) => (
              <IonRouterLink
                key={idx}
                className={
                  'rounded-5 border border-gray-lightButton pb-8 pt-6 pl-5 pr-8 relative font-Outfit text-navy-primary'}
                routerLink={el.href}>
                <h1 className='font-bold text-base md:text-sm'>{el.text}</h1>
                <h4 className='text-sm md:text-xs'>{el.description}</h4>
                <FiArrowRight className='absolute right-3 bottom-3 text-2xl'/>
              </IonRouterLink>
            ))}
          </div>
        </UICard>
        <UICard style={`${tabValue === 'saved-questions' ? 'flex' : 'hidden'} md:flex flex-col md:px-9`}>
          <div className='hidden md:block font-Outfit font-medium text-22 text-black-ink'>Sparade fält</div>
          <div className='font-Outfit font-medium text-22 md:text-sm text-black-ink md:text-brown-subtitle'>
            Här hittar du dina egna sparade fält i hälsodeklarationen</div>
          { isLoading ? <UILoadingIndicator/> : isError ? <UIErrorIndicator/> :
             !ownDeclarationData || ownDeclarationData.length == 0 ?
                 <UINoDataIndicator message='Du har Inga frågor.'/> : (
                <>
                  <div className='text-xs font-Outfit font-semibold text-navy-black py-4'>Namn</div>
                  <IonContent>
                    <IonReorderGroup disabled={!isReorder} onIonItemReorder={(e) => doReorder(e)}
                      className='space-y-2'>
                      {ownDeclarationData?.map((el: any, idx: number) => (
                        <div key={idx} className='rounded-lg border border-gray-lightButton w-full bg-white
                          py-3 px-4 text-sm font-Outfit flex flex-row justify-between items-center relative'>
                          {el.title}
                          {isReorder ? (
                            <IonReorder className='absolute right-2'/>
                          ) : (
                            <>
                              <BsThreeDotsVertical id={`${idx}`}/>
                              <IonPopover trigger={`${idx}`} dismissOnSelect={true} alignment='end' arrow={false}>
                                <IonList lines='none' className='ion-no-padding'>
                                  <IonItem
                                    mode='md'
                                    className='font-Outfit text-sm'
                                    button={true}
                                    onClick={() => goToEdit(el)}>Redigera</IonItem>
                                </IonList>
                              </IonPopover>
                            </>
                          )}
                        </div>
                      ))}
                    </IonReorderGroup>
                  </IonContent>
                  <div className='w-full md:w-1/2 mx-auto mt-auto py-5 md:pb-0'>
                    <UIButton type="full" text={isReorder ? 'Spara' : 'Ändra ordning'}
                      onClick={() => toggleReorder()}/>
                  </div>
                </>
          )}
        </UICard>
      </div>
    </div>
  );
};

export default OwnDeclarationPage;
